import { createAsyncThunk } from "@reduxjs/toolkit";
import { getErrorMessage } from "@fitness-app/utils";

import { type ActionParams, type AsyncThunkCreator } from "../../../index";
import { PRODUCT_REDUCER_NAME } from "../types";
import { CloudFunctions } from "@fitness-app/data-models/http/registry";
import { callFn } from "../../../../helpers/callFn";

type Payload = { id: string };

export const archiveProduct = createAsyncThunk<void, ActionParams<Payload>, AsyncThunkCreator<string>>(
  `${PRODUCT_REDUCER_NAME}/archiveProduct`,
  async ({ payload, onSuccess, onFailure }, { rejectWithValue, extra: { analytics, productApi } }) => {
    try {
      await callFn(productApi, CloudFunctions.products.routes.archiveProduct, { id: payload.id });
      analytics.track("archive_mailing", {
        productId: payload.id,
      });
      onSuccess?.();
    } catch (e) {
      onFailure?.();

      return rejectWithValue(getErrorMessage(e));
    }
  },
);
